import { Component } from '@angular/core';
import { FeatureFlagDirective } from '../../../core/feature-flag.directive';
import { FilterDrawerHeaderComponent } from '../filter-drawer-header/filter-drawer-header.component';
import { FilterClearAllButtonComponent } from '../filter-clear-all-button/filter-clear-all-button.component';
import { FilterDatesComponent } from '../filter-dates/filter-dates.component';
import { FilterLocationComponent } from '../filter-location/filter-location.component';
import { FilterAgencyTagComponent } from '../filter-agency-tag/filter-agency-tag.component';
import { FilterTurnoverRiskComponent } from '../filter-turnover-risk/filter-turnover-risk.component';

@Component({
  selector: 'app-filter-drawer',
  templateUrl: './filter-drawer.component.html',
  styleUrls: ['./filter-drawer.component.scss'],
  standalone: true,
  imports: [
    FeatureFlagDirective,
    FilterDrawerHeaderComponent,
    FilterClearAllButtonComponent,
    FilterDatesComponent,
    FilterLocationComponent,
    FilterAgencyTagComponent,
    FilterTurnoverRiskComponent,
  ]
})
export class FilterDrawerComponent {
}
